export default {
  noLikesFound: 'Keine Likes gefunden',
  noMusicalGenresFound: 'Es gibt noch keine musikalischen Genres',
  noArtistsFound: 'Es gibt noch keine Künstler',
  noSongsFound: 'Es gibt noch keine Songs',
  extraData: 'Zusätzliche Informationen',
  noExtraDataFound: 'Es gibt keine zusätzlichen Informationen',
  typeOfRegister: 'Art des Registers',
  createList: 'Liste erstellen',
  import: 'Importieren',
  invitations: 'Einladungen',
  invite: 'einladen',
  seeGuests: 'Sehen Sie Gäste',
  addNew: 'Neue Hinzufügen',
  mustChargeBeforeCreatePeople: 'Sie müssen Geld berechnen, bevor Sie Personen erstellen',
  invited: 'Eingeladen',
  verified: 'Überprüft',
  notVerified: 'Nicht verifiziert',
  imported: 'Importiert',
  notImported: 'Nicht importiert',
  oneTimePassword: 'Einmaliges Passwort',
  changePassword: 'Kennwort ändern',
  deletePerson: 'Person löschen',
  loading: 'Laden',
  noPeopleRegistered: 'Keine Personen registriert',
  emailOrPhone: 'E-Mail oder Telefon',
  method: 'Methode',
  creationDate: 'Erstellungsdatum',
  actions: 'Aktionen',
  customizedSearch: 'Maßgeschneiderte Suche',
  state: 'Staat',
  createPerson: 'Person erstellen',
  perPage: 'pro Seite',
  loadFile: 'Datei laden',
  organizeData: 'Organisieren von Daten',
  verify: 'Überprüfen',
  pickToImportBusinessesOrPeopleToNewList: 'Wählen Sie aus, ob Sie Unternehmen oder Personen in eine neue oder vorhandene Liste importieren möchten.',
  pickToSavePeopleToList: 'Wählen Sie, ob Sie die Personen, die Sie importieren, in eine Liste speichern möchten.',
  business: 'Business',
  existentList: 'Vorhandene Liste',
  newList: 'Neue Liste',
  noList: 'Ohne Liste',
  listsNotCreated: 'Sie haben noch keine Liste erstellt',
  pickAList: 'Wählen einer Liste',
  typeNameOfTheList: 'Geben Sie den Listennamen ein',
  uploadFileTypeInfo: 'Laden Sie die Datei hoch, in der Ihre Kontakte im CSV- oder xlsx-Format gespeichert sind',
  pickFile: 'Pick-Datei',
  identifyImportedFields: 'Identifizieren Sie jedes Feld basierend auf den Informationen, die es enthalten wird',
  newColumnName: 'Neuer Spaltenname',
  verifyInfoBeforeListCreation: 'Überprüfen Sie, ob die Informationen korrekt sind, bevor Sie die Liste erstellen',
  cancel: 'Abbrechen',
  goBack: 'Zurück',
  continue: 'Weiter',
  message: 'Nachricht',
  other: 'Andere',
  contact: 'Kontakt',
  company: 'Unternehmen',
  address: 'Adresse',
  document: 'Dokument',
  image: 'Bild',
  location: 'Lage',
  observation: 'Beobachtung',
  position: 'Position',
  phone: 'Telefon',
  phonePaste: 'Telefonnummer einfügen',
  phoneWrite: 'Telefonnummer schreiben',
  validPhone: 'Gültige Telefonnummer',
  invalidPhone: 'Ungültiges Telefon',
  switchPasteModePhone: 'Wechseln zur Telefoneingabe im Pastenmodus',
  switchWriteModePhone: 'Wechseln zur Schreibmodus-Telefoneingabe',
  pickWhereToSavePeopleToImport: 'Wählen Sie aus, wo die Personen gespeichert werden sollen, die Sie importieren möchten',
  pleaseAddAValidFile: 'Bitte fügen Sie eine gültige Datei hinzu',
  errorReadingTheFile: 'Beim Lesen der Datei ist ein Fehler aufgetreten.',
  newPerson: 'Neue Person',
  password: 'Passwort',
  addNewPerson: 'Neue Person hinzufügen',
  personSuccessfullyAdded: 'Person erfolgreich hinzugefügt',
  sendEmailTo: 'Senden Sie eine E-Mail an',
  sendSMSTo: 'SMS senden an',
  call: 'Aufrufen',
  downloadContact: 'Download-Kontakt',
  editUser: 'Bearbeiten des Benutzers',
  know: 'Wissen',
  connect: 'Verbinden',
  emailVerify: 'E-Mail-Überprüfung',
  talk: 'sich unterhalten',
  tasks: 'Aufgaben',
  record: 'Aktionen',
  addPersonEmailOrPhoneToNotifyAboutTaskStatus: 'Hinzufügen von Personen-E-Mail oder Telefon zum Senden von Benachrichtigungen über den Aufgabenstatus',
  observations: 'Beobachtungen',
  editTask: 'Bearbeitungsaufgabe',
  youMustAddTheNameOfTheTask: 'Sie müssen den Namen der Aufgabe hinzufügen',
  sameNameTask: 'Eine Aufgabe mit diesem Namen ist bereits vorhanden.',
  taskSuccessfullyDeleted: 'Aufgabe erfolgreich gelöscht',
  noPersonNotes: 'Dieser Benutzer hat keine gespeicherten Notizen',
  insertNewNote: 'Einfügen einer neuen Notiz',
  currentNotes: 'Gespeicherte Notizen',
  editNote: 'Bearbeiten dieser Notiz',
  deleteNote: 'Löschen sie diese Notiz',
  errorUpdatingNotes: 'Notizen konnten nicht aktualisiert werden',
  clickPendingTasks: 'Klicken Sie hier, um Aufgabendetails anzuzeigen',
  tasksList: 'Aufgabenliste',
  tasksDueToday: 'Due Today',
  tasksDueAfter: 'Due After',
  tasksDueBefore: 'Due Before',
  daysRemaining: 'Verbleibende Tage',
  extraManagementAddNewField: 'Hinzufügen eines neuen Informationsfelds',
  extraManagementAditionalInfo: 'Zusätzliche Informationen von Personen Ihrer Marke',
  extraManagementItemAccessApplication: 'Kann nur von einem Administrator dieser Anwendung gesehen werden',
  extraManagementItemAccessPerson: 'Kann von den Menschen gesehen werden',
  extraCreatorShortText: 'Kurzes Textfeld',
  extraCreatorLongText: 'Großes Textfeld',
  extraCreatorList: 'Dropdown-Liste',
  extraCreatorRadioList: 'Radio-Button-Liste',
  extraCreatorCheckList: 'Kontrollkästchenliste',
  extraCreatorEmail: 'E‑mail',
  extraCreatorCreateField: 'Erstellen eines zusätzlichen Informationsfelds',
  extraCreatorEditField: 'Bearbeiten eines zusätzlichen Informationsfelds',
  extraCreatorFieldName: 'Name des Felds',
  extraCreatorFieldType: 'Typ des Feldes',
  extraCreatorFieldAccess: 'Zugang zum Feld',
  extraCreatorAddOptions: 'Hinzufügen der Optionen',
  extraCreatorOption: 'Option',
  extraCreatorApplication: 'Aplication',
  extraCreatorApplicationInfo: 'Erlauben Sie der Anwendung, dieses Feld vom Administrator zu visualisieren und zu ändern.',
  extraCreatorPersonInfo: 'Ermöglicht Benutzern das Visualisieren und Ändern dieses Felds in ihrem Profil',
  extraCreatorAddTags: 'Hinzufügen einiger Tags',
  extraCreatorMessageEnterTag1: 'Keine Ergebnisübereinstimmung',
  extraCreatorMessageEnterTag2: 'Presse',
  extraCreatorMessageEnterTag3: 'um eine neue zu erstellen',
  setResponsible: 'Setzen Sie eine verantwortungsvolle',
  assign: 'Zuweisen',
  selectResponsible: 'Wählen Sie Verantwortlich für diese Liste der neuen Benutzer aus.',
  pickAResponsible: 'Wählen Sie einen Verantwortlichen',
  selectResponsibleSolo: 'Wählen Sie einen Verantwortlichen für diesen Benutzer aus.',
  seeLess: 'Siehe weniger',
  favoriteSongs: 'Lieblingslieder',
  favoriteMusicalGenres: 'Lieblings-Musikgenres',
  favoriteArtists: 'Lieblingskünstler',
  noInstagramSpotifyTags: 'Es gibt noch keine Instagram- oder Spotify-Einstellungen',
  addToList: 'Zur Liste hinzufügen',
  noPersonRecords: 'Dieser Benutzer hat keinen Aktionsdatensatz',
  personAddedToList: 'Person zur Liste hinzugefügt',
  messageSuccessfullySent: 'Nachricht erfolgreich gesendet',
  loadCsv: 'Laden CSV',
  insertInvitedPeopleEmailPhone: 'Fügen Sie alle E-Mails oder Telefone der Personen ein, die Sie einladen möchten, getrennt durch Kommas',
  noEmail: 'Ohne E-Mail',
  noPhone: 'Ohne Telefon',
  noLoadedInvitations: 'Keine geladenen Einladungen',
  downloadCsv: 'CSV herunterladen',
  invitePerson: 'Einladen Person',
  inviteAdministrator: 'Einladen des Administrators',
  invitedPeople: 'Eingeladene Personen',
  sendSms: 'SMS senden',
  resendInvitations: 'Einladungen erneut senden',
  noInvitationsSent: 'Keine Einladungen gesendet',
  noAssistantSelected: 'Sie haben noch keinen Assistenten ausgewählt',
  thisEmailIsGoingToBeSentTo: 'Diese E-Mail wird an',
  assistants: 'Assistenten',
  noPersonSelected: 'Sie haben noch keine Person ausgewählt',
  allTheEventAssistants: 'Alle Assistenten für das Ereignis',
  close: 'Schließen',
  send: 'Senden',
  accept: 'Akzeptieren',
  actualPassword: 'Tatsächliches Passwort',
  change: 'Veränderung',
  youAreAboutToChangeUserPassword: 'Sie sind im Begriff, das Passwort des Benutzers zu ändern, denken Sie daran, der Person das neue Passwort mitzuteilen.',
  saveChanges: 'Speichern von Änderungen',
  onetimePasswordUse: 'Dieses Passwort kann nur einmal verwendet werden',
  sendToPersonEmail: 'Senden an die E-Mail-Adresse der Person',
  sendToPersonPhone: 'Senden an das Telefon der Person',
  generatePassword: 'Passwort generieren',
  passwordCopiedToClipboard: 'Das Kennwort wurde in die Zwischenablage kopiert.',
  errorCopyingThePassword: 'Fehler beim Kopieren des Kennworts',
  doYouWantToDeleteThisPerson: 'Möchten Sie diese Person löschen?',
  personSuccessfullyDeleted: 'Person erfolgreich gelöscht',
  selectFinishingDate: 'Enddatum auswählen',
  pick: 'Wählen',
  selectFinishingHour: 'Auswahl der Abschlussstunde',
  createTask: 'Aufgabe erstellen',
  currentTasks: 'Aktuelle Aufgaben',
  noTasksToDo: 'Es gibt keine Aufgaben zu tun',
  hour: 'Stunde',
  date: 'Datum',
  moveToDoneTasks: 'Wechseln zu erledigten Aufgaben',
  deleteTask: 'Löschaufgabe',
  completedTasks: 'Abgeschlossene Aufgaben',
  noCompletedTasks: 'Es sind keine abgeschlossenen Aufgaben vorhanden.',
  moveToUndoneTasks: 'Wechseln zu rückgängig gemachten Aufgaben',
  errorUpdatingTasks: 'Tasks konnten nicht aktualisiert werden',
  enterTheNameAndDescriptionOfTheTask: 'Geben Sie den Namen und die Beobachtungen der Aufgabe ein',
  insertANewTask: 'Einfügen einer neuen Aufgabe',
  editProfile: 'Profil bearbeiten',
  insertFullName: 'Geben Sie Ihren vollständigen Namen ein',
  insertYourEmail: 'Fügen Sie Ihre E-Mail ein',
  addRoles: 'Hinzufügen von Rollen',
  description: 'Beschreibung',
  userDescription: 'Benutzerbeschreibung',
  notes: 'Notizen',
  addCommentsAboutThisPerson: 'Kommentare zu dieser Person hinzufügen',
  noInformation: 'Keine Informationen',
  updatedCorrectly: 'Richtig aktualisiert',
  searchCountry: 'Suchland',
  countryNotFound: 'Land nicht gefunden',
  uploadDocument: 'Dokument hochladen',
  downloadDocument: 'Dokument herunterladen',
  editDocument: 'Dokument bearbeiten',
  deleteDocument: 'Dokument löschen',
  documents: 'Dokumente',
  deleteDocumentConfirmation: 'Möchten Sie dieses Dokument wirklich löschen?',
  insertDocumentDescription: 'Geben Sie die Dokumentbeschreibung ein',
  editDescription: 'Beschreibung bearbeiten',
  documentSuccessfullyDeleted: 'Dokument wurde erfolgreich gelöscht',
  youMustPickADocumentToEdit: 'Sie müssen ein Dokument auswählen, um es zu bearbeiten.',
  fileSizeMustBeUnderXSize: 'Die angehängte Dateigröße muss unter der Größe der Datei sein.',
  documentSuccessfullyEdited: 'Dokument wurde erfolgreich gelöscht',
  documentSuccessfullyUploaded: 'Dokument erfolgreich hochgeladen',
  editList: 'Bearbeitungsliste',
  listCorrectlyUpdated: 'Liste korrekt aktualisiert',
  personDeletedFromList: 'Person aus Liste gelöscht',
  doYouWantToDeleteThisList: 'Möchten Sie diese Liste löschen?',
  deleteList: 'Liste löschen',
  listDeleted: 'Liste gelöscht',
  lists: 'Listen',
  create: 'Erstellen',
  campaign: 'Kampagne',
  peopleLists: 'Personenlisten',
  peopleListsNotCreated: 'Sie haben noch keine Personenliste erstellt',
  peopleInTheList: 'Personen in der Liste',
  listName: 'Listenname',
  waitUntilTheListGetsCreated: 'Warten Sie, bis die Liste erstellt wurde',
  loadingPeopleFromTheList: 'Laden von Personen aus der Liste',
  noPeopleInThisList: 'Es sind keine Personen in dieser Liste vorhanden.',
  rolesNotCreated: 'Es gibt keine erstellten Rollen',
  code: 'Code',
  nameOfTheRol: 'Name der Rolle',
  newRol: 'Neue Rolle',
  addNewRol: 'Neue Rolle hinzufügen',
  rolSuccessfullyCreated: 'Rol erfolgreich erstellt',
  editRol: 'Bearbeiten von rol',
  rolSuccessfullyEdited: 'Rol erfolgreich bearbeitet',
  columnsTable: 'Spalten',
  edit: 'Bearbeiten',
  loadingPerson: 'Persoon laden',
  weCouldNotFindThisPerson: 'We konden deze persoon niet vinden',
  youMustAddKeyToUpdateUser: 'U moet een sleutel toevoegen om deze persoon bij te werken',
  noDocumentsWereFoundForThisPerson: 'Er zijn geen geüploade documenten gekoppeld aan deze persoon',
  email: 'E-mail',
  verifyEmail: 'Verifieer Email',
  roles: 'Rollen',
  updateAppPublicKey: 'Update de openbare sleutel van de app',
  emailSuccessfullyVerified: 'E-mail succesvol geverifieerd',
  closeProfile: 'Profiel sluiten',
  journey: 'Reis',
  noJourneyForCurrentApp: 'Je applicatie heeft geen bijbehorende Journey, maak er een aan om de huidige Journey-status van deze persoon toe te voegen of te wijzigen',
  changeJourneyCurrentStatus: 'Wijzig de huidige status van de reis van deze persoon',
  dependsOn: 'Hangt af van',
  isDependencyOf: 'Is afhankelijk van',
  changeJourneyCurrentStatusWarning: 'Weet je zeker dat je de huidige status van deze persoon Reis verandert?',
  changeJourneyStatus: 'Wijzig de huidige status van de reis',
  customFields: 'Benutzerdefinierte Felder',
  seeFilters: 'Siehe Filter',
  hideFilters: 'Filter ausblenden',
  peopleFilters: 'Filter der Leute',
  clearFields: 'Felder löschen',
  startEditingMode: 'Starten Sie den Bearbeitungsmodus',
  stopEditingMode: 'Beenden Sie den Bearbeitungsmodus',
  createNewTaskToAssignInBlock: 'Erstellen Sie die neue Aufgabe, die im Block zugewiesen werden soll',
  taskCreatedSuccessfully: 'Aufgabe erfolgreich erstellt',
  chooseTheTypeOfBlockEdition: 'Wählen Sie zunächst die Art der Blockbearbeitung aus, die Sie zum Starten des Prozesses ausführen möchten',
  modifyTheAdditionalDataThatYouWant: 'Ändern Sie die gewünschten zusätzlichen Daten',
  justTheFilledExtraDataAreGoingToBeChanged: 'Nur die zusätzlichen Daten mit einigen ausgefüllten Informationen werden bearbeitet, der Rest wird ignoriert',
  pickTheJourneyStatusToAssignInBlock: 'Wählen Sie einen Reisestatus aus, der im Block zugewiesen werden soll',
  editInBlock: 'Im Block bearbeiten',
  enterInformation: 'Information eingeben',
  modifyAtLeastOneExtraDataToEditInBlock: 'Sie müssen mindestens eine zusätzliche Daten ändern, um im Block bearbeiten zu können',
  addAJourneyStatusToEditInBlock: 'Sie müssen einen Reisestatus hinzufügen, um ihn im Block bearbeiten zu können',
  createAValidTaskToAddInBlock: 'Sie müssen eine gültige Aufgabe erstellen, um sie im Block hinzuzufügen',
  editPeopleInBlock: 'Bearbeiten Sie Personen im Block',
  aListWithThisNameAlreadyExists: 'Eine Liste mit diesem Namen existiert bereits',
  addTheNameOfTheListToBeCreated: 'Fügen Sie den Namen der zu erstellenden Liste hinzu',
  changeExtraData: 'Ändern Sie zusätzliche Informationen',
  pickAtLeastOneTypeOfEditingToEditInBlock: 'Sie müssen mindestens eine Bearbeitungsart auswählen und die entsprechenden Informationen eingeben',
  editInBlockFinishedSuccessfully: 'Bearbeitung im Block erfolgreich abgeschlossen',
  youMustAddTagsInOrderToFilterExtraData: 'Sie müssen zusätzlichen Daten Tags hinzufügen, um sie nach Tags zu filtern',
  menu: 'Speisekarte',
  of: 'von',
  responsible: 'Verantwortlich',
  fullName: 'Vollständiger Name',
  firstName: 'Vorname',
  onlyStaticListsAreListedBelow: 'Im Folgenden sind nur statische Listen aufgeführt',
  listType: 'Listentyp',
  static: 'Statisch',
  dynamic: 'Dynamisch',
  mainPhone: 'Haupttelefon',
  profile: 'Profil',
  orderExtraData: 'Bestellen Sie zusätzliche Daten',
  tags: 'Stichworte',
  noTags: 'Ohne Tags',
  privacyTermsWarning: 'Das Exportieren von Daten ist keine gute Praxis, da dies möglicherweise gegen das Gesetz von 1581 und die DSGVO verstößt. Möchten Sie die Daten wirklich exportieren?',
  registerName: 'Registername?',
  sendEmail: 'E-Mail senden',
  editResponsible: 'Verantwortlich bearbeiten',
  permissionsFor: 'Berechtigungen für',
  // Importing people info
  numberOfRows: 'Reihenanzahl',
  totalPeople: 'Insgesamt Menschen',
  uniquePeople: 'Einzigartige Menschen',
  savedPeople: 'Gerettete Menschen',
  updatedPeople: 'Aktualisierte Personen',
  insertedPeople: 'Eingefügte Personen',
  duplicatedPeople: 'Doppelte Menschen',
  importCompleted: 'Import abgeschlossen',
  importingBusinesses: 'Unternehmen importieren',
  creatingList: 'Liste erstellen',
  peopleRegistrationInformation: 'Registrierungsinformationen der Personen für den ausgewählten Zeitraum',
  businessInformationItems: 'Geschäftsinformationsspalten',
  personalInformationItems: 'Spalten für persönliche Informationen',
  extraDataItems: 'Zusätzliche Informationsspalten',
  doYouWantToDeleteThisRol: 'Dou möchten Sie diese Rolle wirklich löschen',
  rolSuccessfullyDeleted: 'Rol erfolgreich gelöscht',
  addSelectedUsersToList: 'Fügen Sie ausgewählte Benutzer zur Liste hinzu',
  usersSuccessfullyAddedToList: 'Benutzer erfolgreich zur Liste hinzugefügt'
}
